import React from 'react';
import { GruntworxPageLayout } from 'components/Integrations/integration-modules/gruntworx/components';
import { GruntworxSettings } from './GruntworxSettings';

/**
 * Simple wrapper for GruntWorx settings page
 */
export const GruntworxLandingView = () => (
  <GruntworxPageLayout>
    <GruntworxSettings />
  </GruntworxPageLayout>
); 